export default __webpack_public_path__ + "static/media/aboutimg.b708ac7c.png";